





















import { Component, Prop, Vue } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import {
  FormAction,
  diagnoseAccess,
  unitKategoriLabel,
  AccessDiagnosis,
} from "@/utils/form-access";
import { formRoleOwners } from "@/utils/role-marker";

/**
 * Drop-in pengganti `v-btn` yang sadar-akses form (RBAC).
 *
 * Kalau user TIDAK punya akses, tombol tetap tampil tapi disabled, dan hover
 * memunculkan tooltip berisi penjelasan + daftar profesi yang berhak mengakses
 * (diturunkan dari matriks RBAC yang sama, `formRoleOwners`). Tidak mendefinisikan
 * aturan baru — hanya presentasi UX (otorisasi asli tetap di server).
 *
 * Semua prop v-btn (color/small/text/icon/x-small/...) & listener diteruskan apa
 * adanya via `$attrs`/`$listeners`.
 *
 * Pemakaian:
 *   <access-button code="persetujuan_penggunaan_obat" action="create"
 *     color="primary" small :disabled="readOnly" @click="tambah()">Tambah</access-button>
 */
@Component({ name: "AccessButton", inheritAttrs: false })
export default class AccessButton extends Vue {
  /** Kode form RBAC (mis. "persetujuan_penggunaan_obat"). */
  @Prop({ required: true, type: String }) readonly code!: string;
  /** Action yang dicek (view/create/edit/sign/print/report). */
  @Prop({ default: "view", type: String }) readonly action!: FormAction;
  /** Disabled karena state workflow (readOnly/busy) — terpisah dari akses. */
  @Prop({ default: false, type: Boolean }) readonly disabled!: boolean;

  get diagnosis(): AccessDiagnosis {
    const u = userModule.user;
    return diagnoseAccess(u?.unit_id, u?.profesi, u?.role?.id, this.code, this.action);
  }

  get hasAccess(): boolean {
    if (!this.code) return true;
    return this.diagnosis.hasAccess;
  }

  /** Daftar profesi/peran yang berhak (untuk pesan "siapa yang bisa"). */
  get ownerLabels(): string {
    return this.code
      ? formRoleOwners(this.code)
          .map((o) => o.label)
          .join(", ")
      : "";
  }

  /** Pesan tooltip singkat — cukup teks restriksinya. */
  get tooltipText(): string {
    const d = this.diagnosis;
    if (d.reason === "unit_mismatch") {
      return `Khusus unit: ${d.allowedUnitKategoriForProfesi.map(unitKategoriLabel).join(", ")}`;
    }
    if (d.reason === "no_rule") {
      return "Tidak tersedia untuk aksi ini";
    }
    return this.ownerLabels ? `Khusus: ${this.ownerLabels}` : "Tidak ada akses";
  }
}
